module.exports = __webpack_public_path__ + "f995f642b0f870c9faf52635f12baca4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/partner-logo.png
// module id = 3250
// module chunks = 0